import { Element, Node } from 'slate';
import { BlockElement } from '../../types';

export const orderedListType = 'ordered-list';
export const unorderedListType = 'unordered-list';
export const listItemType = 'list-item';

export const isNodeTypeOrderedList = (node: Node): node is BlockElement =>
  Element.isElement(node) && node?.type === orderedListType;

export const isNodeTypeUnorderedList = (node: Node): node is BlockElement =>
  Element.isElement(node) && node?.type === unorderedListType;

export const isList = (node: Node): node is BlockElement =>
  isNodeTypeOrderedList(node) || isNodeTypeUnorderedList(node);

export const isListItem = (node: Node): node is BlockElement =>
  Element.isElement(node) && node?.type === listItemType;
